import React from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useSidebarController } from '../../hooks/useSidebarState';

export const DashboardLayout = ({ children, title = 'Dashboard' }) => {
  const sidebar = useSidebarController();

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50 dark:bg-slate-950">
      <Sidebar
        isInline={sidebar.isInline}
        isCollapsed={sidebar.isCollapsed}
        onToggleCollapsed={sidebar.toggleCollapsed}
        isMobileOpen={sidebar.isMobileOpen}
        onCloseMobile={sidebar.closeMobile}
      />
      <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
        <Topbar
          title={title}
          showMenuButton={!sidebar.isInline}
          onMenuClick={sidebar.openMobile}
        />
        <main className="flex-1 min-h-0 overflow-auto p-6 md:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};
